import React from "react";
import DTN from "../../assets/images/app/dtn-app.svg";
import Apischain from "../../assets/images/app/apischain.svg";
import AgriMiner from "../../assets/images/app/agriminer-app.svg";
import Marketplaces from "../../assets/images/app/shopping-store.svg";
import SocialMarketplace from "../../assets/images/app/analytics.svg";
import CMomarketplace from "../../assets/images/app/store-management.svg";
import CFonMarketplace from "../../assets/images/app/store.svg";
import AgriServiceMarketplace from "../../assets/images/app/consulting.svg";
import AgriOutputMarketplace from "../../assets/images/app/AgriOutputMarketplace.svg";


import TechnologySubSection from "./TechnologySubSection";
import Title from "../titles/Title";

const TechnologySection = () => {
  const feature1 = [
    "    Easy to monitor & tracking of sustainable agri assets and farms",
    "    Quality assurance of sustainable agri assets and farms",
   
  ];

  const feature2 = [
    "New business line for managing sustainable agri-assets",
    "Access to rural eco-entrepreneur and contributors partnerships",
    "Expanded operational capacity and revenue streams",
    "Support multiple marketplaces for thr trusted transactions"
  ];

  const feature3 = [
    "Farm onboarding Management: Create and manage farms efficiently",
    "Offline Registration: requesting for creating users and manage these users.",
  ];
  const feature4 = [
    "onMarketplace provides a wide array of organic honey products, including fresh produce and processed items, offering consumers a diverse selection of organic choices.",
    "Detailed information about each product, including its source, farming methods, certifications, and nutritional facts, helps customers make informed choices.",
    "The products are guaranteed to be authentic as they meet strict organic certification standards.",
  ];

  const feature5 = [
    "Simplifies tracking and management of contract farming activities.",
    "Provides access to a diverse network of AAMC.",
  ];

  const feature6 = [
    "Access a diverse range of farm enterprises and agri-asset investment opportunities.",
    "Simplifies the process for brands to place and manage contract manufacturing orders.",
    "Offers clear and structured agreements between brands and processors.    ",
  ];

  const feature8 = [
    "  A unified space for beekeepers to find and offer pollination services, improving accessibility and efficiency.    ",
    "Beekeepers can tailor pollination services based on specific crop needs and requirements.",
  ];
 

  const feature10 = [
    "Brands can connect with manufacturers for producing honey products. ",
    "Easy collaboration between brands and manufacturers to create customized honey products. ",
  ];

  const feature9 = [
    "Enables listing, searching, bidding, and secure transactions for raw, semi-processed, and processed agricultural products with verified user profiles and real-time pricing.",
  ];
  const appSectionData = [
    {
      id: "DTNApp",
      href: "https://drive.google.com/drive/folders/1FkI_AlLHbRZNHJCpJd_oVodjztrafV-Q?usp=sharing",
      title: "DTN App",
      description:
        "DTN is an management application which is used to manage of all the sustainable agri assets and sites in the network.",
      image: DTN,
      features: feature1,
    },
    {
      id: "ACNNetwork",
      href: "https://siapischain-abn.gbrapp.com/auth/undefined/signup",
      title: "ACN Network",
      description:
        "The Apischain network (ACN) helps to bring sustainablility and It will help beekeepers, commercial farmer and buyers who want to buy organic honey and related products.",
      image: Apischain,
      features: feature2,
      test: "true",
    },

    {
      id: "AgriMinerApp",
      href: "https://play.google.com/store/apps/details?id=com.FENapp.agriminer&pli=1?usp=sharing",
      title: "AgriMiner App",
      description:
        "AgriMiner is a robust agricultural application designed to bridge the gap between agricultural organizations and Agri-producers, as well as other users within the agricultural community. This innovative app serves as a central platform for managing farms and facilitating interactions between registered users, ultimately revolutionizing the way agriculture is conducted and managed.",
      image: AgriMiner,
      features: feature3,
    },
  ];
  const marketplaceData = [
    {
      id: "onMarketplace",
      href: "https://siapischain-abn.gbrapp.com/auth/undefined/signup",
      title: "onMarketplace",
      description:
        " ApisChain onmarketplace offers a diverse selection of high-quality organic goods, from fresh produce to processed items, catering to health-conscious consumers while supporting sustainable farming practices.",
      image: Marketplaces,
      features: feature4,
      test: "true",
    },

    {
      id: "SocialonMarketplace",
      href: "https://siapischain-abn.gbrapp.com/auth/undefined/signup",
      title: "Social CFonMarketplace",
      description:
        " Social CFonMarketplace, provided by the ApisChain network, is a platform where manufacturers can place contract farming orders. ",
      image: CFonMarketplace,
      features: feature5,
      test: "true",
    },

    {
      id: "SocialiaaMarketplace",
      href: "https://siapischain-abn.gbrapp.com/auth/undefined/signup",
      title: "Social iaaMarketplace",
      description:
        "Social iaaMarketplace opens the door for eco contributor to engage in honey assets, offering a seamless experience to allocate capital, diversify portfolios, and contribute to the agricultural sector's growth.",
      image: SocialMarketplace,
      features: feature6,
      test: "true",
    },

    {
      id: "AgrocareMarketplace",
      href: "https://siapischain-abn.gbrapp.com/auth/undefined/signup",
      title: "Social CMonMarketplace",
      description:
        "Apischain offers a social CMomarketplace that enables brands to provide contract manufacturing services for honey products.",
      image: CMomarketplace,
      features: feature10,
      test: "true",
    },
    {
      id: "AgriServiceMarketplace",
      href: "https://siapischain-abn.gbrapp.com/auth/undefined/signup",
      title: "AgriService Marketplace",
      description:
        "AgriService Marketplace is a platform provided by Apischain that connects beekeepers with agricultural producers in need of pollination services. It enables beekeepers to offer their bees for crop pollination, enhancing yields and promoting sustainable farming practices.        ",
      image: AgriServiceMarketplace,
      features: feature8,
      test: "true",
    },

    {
      id: "AgriOutputMarketplace",
      href: "https://siapischain-abn.gbrapp.com/auth/undefined/signup",
      title: "AgriOutputMarketPlace Marketplace",
      description:
        "AgriOutputMarketPlace facilitates the buying and selling of raw, semi-processed and processed fostering efficient trade in agricultural commodities.",
      image: AgriOutputMarketplace,
      features: feature9,
      test: "true",
    },
  ];

  return (
    <>
      <TechnologySubSection data={appSectionData} />
      <div id="Marketplaces">
        <Title heading="Marketplaces" classname="text-center" />
        <TechnologySubSection data={marketplaceData} />
      </div>
    </>
  );
};

export default TechnologySection;
